module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/notifications/notifications.component.scss
// module id = ./src/app/shared-components/notifications/notifications.component.scss
// module chunks = main